import { API_ENDPOINTS } from '../constants/api-endpoints';
import { API, API_UPLOAD } from './api-config';

const {
  APPLICATION: {
    FIND_ALL,
    FIND_ONE,
    MY_GOV_GET,
    MY_GOV_GET_CHANGE,
    MY_GOV_INVOICE,
    HISTORY,
    CHECK_DIPLOMAS,
    HISTORY_CURRENT,
    EXAM_DATA,
    EXAM_DATA_RESULT,
    EXAM_DATA_ORAL,
    EXAM_DATA_ORAL_SECOND,
    HISTORY_WORK,
    UPDATE_ONE,
    PATCH_ONE,
    DELETE_ONE,
    CREATE_ONE,
    UPLOAD_CERTIFICATES,
    UPLOAD_TEST_TAKERS,
    UPLOAD_TEST_TAKERS_TO_OTHERS,
    UPLOAD_VERBAL_TO_TWICE,
    UPLOAD_VERBAL_TO_OTHER,
    UPLOAD,
    UPDATE,
    UPDATE_CERTIFICATE,
    UPLOAD_INVOICE,
    UPLOAD_FILE,
    CONFIRM_ONE,
    CHANGE_STATUS,
    DECLINE_ONE,
    STATS,
    NOTIFICATIONS,
    MY_GOV_GET_CHECK,
    REGISTER_MY_GOV_TASK,
    APPLICATION_GET_CHECK,
  },
} = API_ENDPOINTS;

export const ApiApplication = {
  fetchAll: (params?: Record<string, any>) => {
    return API({
      path: FIND_ALL,
      method: 'GET',
      params,
    });
  },
  fetchOne: (id: string | number) => {
    return API({
      path: FIND_ONE,
      method: 'GET',
      pathParams: { id },
    });
  },
  getMyGovApplication: () => {
    return API({
      path: MY_GOV_GET,
      method: 'GET',
    });
  },
  getMyGovApplicationChange: (id: number) => {
    return API({
      path: MY_GOV_GET_CHANGE,
      method: 'GET',
      params: {
        task_id: id,
      },
    });
  },
  getMyGovApplicationCheck: (id: number) => {
    return API({
      path: MY_GOV_GET_CHECK,
      method: 'GET',
      pathParams: { id },
    });
  },
  registerMyGovTask: (id: number) => {
    return API({
      path: REGISTER_MY_GOV_TASK,
      method: 'GET',
      pathParams: { id },
    });
  },
  getApplicationCheck: (id: number) => {
    return API({
      path: APPLICATION_GET_CHECK,
      method: 'GET',
      params: {
        embed: 'user',
        taskId: id,
      },
    });
  },
  getMyGovInvoice: (id: string) => {
    return API({
      path: MY_GOV_INVOICE,
      method: 'GET',
      pathParams: { id },
    });
  },
  getHistory: (id: string) => {
    return API({
      path: HISTORY,
      method: 'GET',
      params: {
        application: id,
        embed: 'user',
      },
    });
  },
  checkDiplomas: (pinfl: string | number) => {
    return API({
      path: CHECK_DIPLOMAS,
      method: 'GET',
      pathParams: { pinfl },
    });
  },
  getCurrentWork: (id: string) => {
    return API({
      path: HISTORY_CURRENT + id,
      method: 'GET',
    });
  },
  getWorkHistory: (id: string) => {
    return API({
      path: HISTORY_WORK + id,
      method: 'GET',
    });
  },
  createOne: (data: Record<string, any>) => {
    return API({
      path: CREATE_ONE,
      method: 'POST',
      data,
    });
  },
  examdates: (data: Record<string, any>) => {
    return API({
      path: EXAM_DATA,
      method: 'POST',
      data,
    });
  },
  examdatesResults: (data: Record<string, any>) => {
    return API({
      path: EXAM_DATA_RESULT,
      method: 'POST',
      data,
    });
  },
  examdatesOral: (data: Record<string, any>) => {
    return API({
      path: EXAM_DATA_ORAL,
      method: 'POST',
      data,
    });
  },
  examdatesOral_SECOND: (data: Record<string, any>) => {
    return API({
      path: EXAM_DATA_ORAL_SECOND,
      method: 'POST',
      data,
    });
  },
  changeStatus: (
    id: string | number,
    status: string,
    message: string,
    isPrimary?: string | undefined,
    prematureRecipient?: string | undefined
  ) => {
    const data: any = {
      status,
      message,
    };
    if (prematureRecipient) {
      data.prematureRecipient = prematureRecipient;
    } else if (isPrimary) {
      data.isPrimary = isPrimary;
    }
    return API({
      path: CHANGE_STATUS,
      pathParams: { id },
      method: 'PATCH',
      data,
    });
  },
  // upload: (data: Record<string, any>) => {
  //   return API_UPLOAD({
  //     path: UPLOAD,
  //     method: 'POST',
  //     data,
  //   });
  // },
  upload: (data: Record<string, any>) => {
    return API({
      path: UPLOAD,
      method: 'POST',
      data,
    });
  },
  update: (id: string | number, data: Record<string, any>) => {
    return API({
      path: UPDATE,
      method: 'PUT',
      pathParams: { id },
      data,
    });
  },
  updateCertificate: (id: string | number, data: Record<string, any>) => {
    return API({
      path: UPDATE_CERTIFICATE,
      method: 'PUT',
      pathParams: { id },
      data,
    });
  },
  fileUpload: (data: Record<string, any>) => {
    return API_UPLOAD({
      path: UPLOAD_FILE,
      method: 'POST',
      data,
    });
  },
  certificatesUpload: (data: Record<string, any>) => {
    return API_UPLOAD({
      path: UPLOAD_CERTIFICATES,
      method: 'POST',
      data,
    });
  },
  confirmedToTestTakersUpload: (data: Record<string, any>) => {
    return API_UPLOAD({
      path: UPLOAD_TEST_TAKERS,
      method: 'POST',
      data,
    });
  },
  testTakersToOtherUpload: (data: Record<string, any>) => {
    return API_UPLOAD({
      path: UPLOAD_TEST_TAKERS_TO_OTHERS,
      method: 'POST',
      data,
    });
  },
  verbalToTwiceUpload: (data: Record<string, any>) => {
    return API_UPLOAD({
      path: UPLOAD_VERBAL_TO_TWICE,
      method: 'POST',
      data,
    });
  },
  verbalToOtherUpload: (data: Record<string, any>) => {
    return API_UPLOAD({
      path: UPLOAD_VERBAL_TO_OTHER,
      method: 'POST',
      data,
    });
  },
  invoiceUpload: (id: string | number, data: Record<string, any>) => {
    return API({
      path: UPLOAD_INVOICE,
      method: 'PUT',
      pathParams: { id },
      data,
    });
  },
  updateOne: (id: string | number, data: Record<string, any>) => {
    return API({
      path: UPDATE_ONE,
      method: 'PUT',
      pathParams: { id },
      data,
    });
  },
  patchOne: (id: string | number, data: Record<string, any>) => {
    return API({
      path: PATCH_ONE,
      method: 'PATCH',
      pathParams: { id },
      data,
    });
  },
  deleteOne: (id: string | number) => {
    return API({
      path: DELETE_ONE,
      method: 'DELETE',
      pathParams: { id },
    });
  },
  confirmOne: (id: string | number, data: Record<string, any>) => {
    return API({
      path: CONFIRM_ONE,
      method: 'PATCH',
      pathParams: { id },
      data,
    });
  },
  declineOne: (id: string | number, data: Record<string, any>) => {
    return API({
      path: DECLINE_ONE,
      method: 'PATCH',
      pathParams: { id },
      data,
    });
  },
  fetchStats: () => {
    return API({
      path: STATS,
      method: 'GET',
    });
  },
  fetchNotifications: (params?: Record<string, any>) => {
    return API({
      path: NOTIFICATIONS,
      method: 'GET',
      params,
    });
  },
};
